"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  // FAILED_CONNECTION_NOTIFICATION: '',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: "{Retry}.",
  // SLOW_CONNECTION_NOTIFICATION: '',
  // 'Chat': 'Chat',
  // 'Download file': '',
  // 'Microphone off': '',
  // 'Microphone on': '',
  'Listening…': 'Lytter…',
  Retry: 'prøv igjen',
  Send: 'Send',
  Sending: 'sender',
  Speak: 'Snakk',
  // 'Starting…': '',
  Tax: 'Skatt',
  Total: 'Totalt',
  'Type your message': 'Skriv inn melding',
  'Upload file': 'Last opp fil',
  VAT: 'MVA' // 'X minutes ago': xMinutesAgo

};
exports.default = _default;